import { LegalPage } from '../components/landing/LegalPage';
import { privacyPolicy } from '../legal/documents';

export function Privacy() {
  return <LegalPage source={privacyPolicy} />;
}
